import helpers from '../../helpers'
import moment from 'moment'

async function isAuthenticated () {
  let token = await helpers.storage.get('token')
  let exp = await helpers.storage.get('exp')

  if (!token) { return false }

  let payLoad = helpers.unwrap(token)

  if (!payLoad) { return false }

  let tokenExpiration = moment(exp)

  console.log(tokenExpiration)

  return true
}

function handleAuthRoute (router) {
  if (!router) return

  router.beforeEach(async (to, from, next) => {
    // console.log(to)

    if (to.meta.auth) {
      const loggedIn = await isAuthenticated()

      if (loggedIn) {
        next()
      } else {
        next({ name: 'LandingPage' })
      }
    } else {
      next()
    }
  })
}

const RouteHandler = {

  install (Vue, options) {
    if (!options || !options.router) { throw new Error('Route Handler expects router module') }

    handleAuthRoute(options.router)
  }
}

export default RouteHandler



// WEBPACK FOOTER //
// ./src/services/routehandler/index.js